/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';
import { stringify } from 'qs';

import { AccessTokenResponse } from '../models/AccessTokenResponse';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class OauthApiResource {

    /**
     * Authorization endpoint
     * 
     * @param responseType Response type (&#x60;code&#x60; supported)
     * @param clientId Client id
     * @param redirectUri Redirect URI
     * @param scope Requested access scope or scopes (space separated)
     * @param state Opaque value used to maintain state
     */
    public authorize(query?: { responseType: string, clientId: string, redirectUri?: string, scope?: string, state?: string }, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/oauth/authorize';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath,
            params: query
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Delete the current Oauth2 bearer token (for signout)
     * 
     */
    public deleteToken(axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/oauth/token';
        let reqConfig = {
            ...axiosConfig,
            method: 'DELETE',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return an Oauth2 Authorization bearer token, given a username and password
     * 
     * @param grantType Type of grant (&#x60;password&#x60; and &#x60;authorization_code&#x60; supported)
     * @param code Authorization code
     * @param redirectUri Redirect URI
     * @param clientId Client id
     * @param username Username to authenticate
     * @param password Password to authenticate
     * @param scope Requested access scope or scopes (space separated)
     */
    public issueAccessToken(grantType?: Partial<string>, code?: Partial<string>, redirectUri?: Partial<string>, clientId?: Partial<string>, username?: Partial<string>, password?: Partial<string>, scope?: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<AccessTokenResponse> {
        const reqPath = '/oauth/token';
        let reqFormParams = {
            grant_type: grantType,
            code: code,
            redirect_uri: redirectUri,
            client_id: clientId,
            username: username,
            password: password,
            scope: scope
        };
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
            data: stringify(reqFormParams)

        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

}

export const OauthApi = new OauthApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/OauthApi.ts